export const getAudienceActionsStyle = (_, { palette = {} }) => ({
  actionsContainer: {
    '& .audience-actions-body': {
      display: 'flex',
      flexDirection: 'row',
      gap: '12px',
      width: '100%',
    },

    '& button': {
      backgroundColor: palette.neutralLighterAlt,
      border: 'none',
      borderRadius: 4,
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.08)',
      flexGrow: 1,
      padding: '18px 16px',

      '& .ms-Button-textContainer': {
        marginLeft: 8,
      },

      '& .ms-Button-description': {
        fontSize: 14,
      },
    },

    '& .btn-create-audience-signal': {
      marginLeft: '2px',
      marginBottom: '2px',
      flex: 1,
    },

    '& .btn-browse-audience-signal': {
      marginLeft: '2px',
      marginBottom: '2px',
      flex: 1,
    },

  },
});
